/**** mgt.Driver */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  apiType: apiTypes.REPORT_API,
  table: 'dqa_group',
  title: "Группы",
  elemsOnPage: 100,
  fields: [
    {
      name: 'group_id',
      title: 'ID группы',
      type: 'number',
      width: '120px',
      index: true
    },
    {
      name: 'group_name',
      title: 'Название группы',
      type: 'text',
      width: '120px',
    }
  ],
  newTemplate: {
    group_id: null,
    group_name: ''
  },
  defaultSort: {
    field: 'group_id',
    direction: 'desc'
  },
  makeIdOnInsert: true,
  import: {
    header: [
      {
        title: 'group_id',
        field: 'group_id',
      },
      {
        title: 'group_name',
        field: 'group_name',
      },
    ],
    example: `1;text`,
 },
};

export default config;
